import * as React from 'react';

import { IPostFeedProps, PostFeed } from './PostFeed';
import { PostFeedErrorBoundary } from './components/ErrorBoundary';

export const PostFeedWithErrorBoundary: React.FC<IPostFeedProps> = (props) => {
  return (
    <PostFeedErrorBoundary>
      <PostFeed {...props} />
    </PostFeedErrorBoundary>
  );
};
